module.exports = __webpack_public_path__ + "static/media/slider1.68273e75.jpg";